import axios from "@/api/axios";

const HIDE_LOADING = true;

// 欢迎页面数据
export const queryWelcomeData = data => axios({ url: "/api/page/data/LR",  data, config: { noLoading: HIDE_LOADING } });

//登录
export const login = data => axios({ 
  url: "/api/user/login",
  method: 'post',
  data,
});

// 游客登录
export const guestLogin = data => axios({ 
  url: "/api/user/guest",
  method: 'post',
  data,
});

// 注册
export const register = data => axios({ 
  url: "/api/user/register",
  method: 'post',
  data,
});
export const querySignupAreaCode = data => axios({ url: "/api/signup/phone/area/code",  data, config: { noLoading: HIDE_LOADING } });
export const registerOTP = data => axios({ 
  url: "/api/user/sms/send/register",
  method: 'post',
  data,
});

// 用户名注册
export const customRegister = data => axios({ 
  url: "/api/user/custom/register",
  method: 'post',
  data,
});

export const saveInviteCode = data => axios({ 
  url: "/api/user/register/flag",
  method: 'post',
  data,
});

// 绑定手机号
export const bindAccount = data => axios({ 
  url: "/api/user/bind",
  method: 'post',
  data,
});
export const bindAccountOTP = data => axios({ 
  url: "/api/user/sms/send/bind",
  method: 'post',
  data,
});

// 登出
export const logout = data => axios({ 
  url: "/api/user/logout",
  method: 'post',
  data,
});

// 忘记密码
export const forgetPwdOTP = data => axios({ 
  url: "/api/user/sms/send/resetLoginPwd",
  method: 'post',
  data,
});
export const forgetPwd = data => axios({ 
  url: "/api/reset/login/pwd",
  method: 'post',
  data,
});
// 修改密码
export const modifyLoginPwd = data => axios({ 
  url: "/api/user/modifyPasswordLogin",
  method: 'post',
  data,
});
// 修改交易密码
export const modifyTradePwd = data => axios({ 
  url: "/api/user/modifyPasswordTrade",
  method: 'post',
  data,
});

// 重置交易密码
export const resetTradePwdOTP = data => axios({ 
  url: "/api/user/sms/send/resetTradePwd",
  method: 'post',
  data,
});
export const resetTradePwd = data => axios({ 
  url: "/api/reset/trade/pwd",
  method: 'post',
  data,
});

//实名
export const queryIdentityType = data => axios({ url: "/api/user/identity/type",  data });
export const queryIdentityInfo = data => axios({ url: "/api/user/identity/fetch", data });
export const updateUserBaseInfo = data => axios({ 
  url: "/api/user/identity/base",
  method: 'post',
  data,
});
export const uploadIdentity = data => axios({ 
  url: "/api/user/identity/upload",
  method: 'post',
  data,
});

// uploadImg
export const uploadImg = data => axios({ 
  url: "/api/common/uploadImg",
  method: 'post',
  data,
});

// 国家列表 
export const queryNation = data => axios({ url: '/api/user/country', data});

// 配置
export const queryConfig = data => axios({ url: "/api/config/fetch",  data, config: { noLoading: HIDE_LOADING } });
export const queryAppVersion = data => axios({ url: "/api/app/version",  data, config: { noLoading: HIDE_LOADING } });

// 客服
export const customerSupport = data => axios({ url: "/api/customerSupport",  data });

// 分享
export const shareSocialMedia = data => axios({ url: "/api/user/share",  data });
export const successShared = data => axios({ url: "/api/user/share/success",  data });

// 关注
export const followSocialMedia = data => axios({ url: "/api/user/follow",  data });

// 用户信息
export const getUserInfo = data => axios({ url: "/api/user/info",  data, config: { noLoading: HIDE_LOADING } });
export const getBalance = data => axios({ url: "/api/balance",  data, config: { noLoading: HIDE_LOADING } });
export const queryAvatar = data => axios({ url: "/api/material/avatar",  data });
export const queryBadgeData = data => axios({ url: "/api/badge/data",  data });
export const updateUserInfo = data => axios({ 
  url: "/api/user/modify",
  method: 'post',
  data,
});

// vip等级
export const queryVipInfo = data => axios({ url: "/api/vip/card/fetch",  data, config: { noLoading: HIDE_LOADING } });
export const claimVipDailyReward = data => axios({ 
  url: "/api/vip/card/daily/rewards/claim",
  method: 'post',
  data,
});
export const claimVipDepositRebates = data => axios({ 
  url: "/api/vip/card/deposit/rewards/claim",
  method: 'post',
  data,
});
export const claimVipRebateReward = data => axios({ 
  url: "/api/vip/card/rebate/rewards/claim",
  method: 'post',
  data,
});
export const claimVipMonthlyReward = data => axios({ 
  url: "/api/vip/card/monthly/rewards/claim",
  method: 'post',
  data,
});

// 亲友卡
export const queryFriendCard = data => axios({ url: "/api/friend/card/fetch",  data, config: { noLoading: HIDE_LOADING } });
export const queryFriendCardRewards = data => axios({ url: "/api/friend/card/rewards/record",  data, config: { noLoading: HIDE_LOADING } });
export const claimFCDepositReward = data => axios({ 
  url: "/api/friend/card/deposit/rewards/claim",
  method: 'post',
  data,
});
export const claimFCTurnoverReward = data => axios({ 
  url: "/api/friend/card/turnover/rewards/claim",
  method: 'post',
  data,
});

// 拉新排行榜
export const queryInviteRanking = data => axios({ url: "/api/invite/rankings/fetch",  data, config: { noLoading: HIDE_LOADING } });
export const claimInviteRankingReward = data => axios({ 
  url: "/api/invite/rankings/claim",
  method: 'post',
  data,
});

// deposit
export const queryDepositProduct = data => axios({ url: '/api/recharge/method', data, config: { noLoading: HIDE_LOADING }});
export const queryDepositBank = data => axios({ url: '/api/recharge/bank', data, config: { noLoading: HIDE_LOADING } });
export const queryDepositAmount = data => axios({ url: '/api/recharge/amount', data, config: { noLoading: HIDE_LOADING }});
export const preCreateDeposit = data => axios({ 
  url: "/api/recharge/preCreate",
  method: 'post',
  data,
});
export const createDeposit = data => axios({ 
  // url: "/api/recharge/create",
  url: "/api/recharge/build",
  method: 'post',
  data,
});
export const queryDepositOrder = data => axios({ url: '/api/recharge/fetch', data, config: { noLoading: HIDE_LOADING }});
export const queryCoupon = data => axios({ url: '/api/coupon/fetch', data, config: { noLoading: HIDE_LOADING }});

// withdraw
export const queryWithdrawBank = data => axios({ url: '/api/withdraw/bankList', data, config: { noLoading: HIDE_LOADING } });
export const queryWithdrawAccount = data => axios({ url: '/api/user/bankCard/wallet/account', data, config: { noLoading: HIDE_LOADING } });
export const saveWithdrawAccount = data => axios({ 
  url: "/api/user/bankCard/create",
  method: 'post',
  data,
});
export const createWithdraw = data => axios({ 
  url: "/api/withdraw/create",
  method: 'post',
  data,
});
export const queryWithdrawOrder = data => axios({ url: '/api/withdraw/fetch', data, config: { noLoading: HIDE_LOADING }});

//game
export const queryGameType = data => data.hasLogin ? axios({ url: "/api/game/type",  data, config: { noLoading: HIDE_LOADING } }) : axios({ url: "/api/open/game/type",  data, config: { noLoading: HIDE_LOADING } });
export const queryGameProvider = data => data.hasLogin ? axios({ url: "/api/manuf/fetch",  data, config: { noLoading: HIDE_LOADING } }) : axios({ url: "/api/open/manuf/fetch",  data, config: { noLoading: HIDE_LOADING } });
export const queryGameList = data =>data.hasLogin ? axios({ url: "/api/game/fetch",  data, config: { noLoading: HIDE_LOADING } }) : axios({ url: "/api/open/game/fetch",  data, config: { noLoading: HIDE_LOADING } });
export const queryGameHot = data => data.hasLogin ? axios({ url: "/api/game/fetch/hot",  data, config: { noLoading: HIDE_LOADING } }) : axios({ url: "/api/open/game/fetch/hot",  data, config: { noLoading: HIDE_LOADING } });
export const queryGameNew = data => data.hasLogin ? axios({ url: "/api/game/fetch/live",  data, config: { noLoading: HIDE_LOADING } }) : axios({ url: "/api/open/game/fetch/live",  data, config: { noLoading: HIDE_LOADING } });
export const searchGame = data => axios({ url: "/api/open/game/search",  data });
export const querySearchDiscover = data => axios({ url: "/api/open/game/searchDiscover",  data });
export const queryGameCollect = data =>  axios({ url: "/api/user/game/collect/fetch",  data });
export const queryGameHelper = data =>  axios({ url: "/api/game/helper",  data, config: { noLoading: true } });
export const queryGameRecord = data =>  axios({ url: `/api/game/record/${data.type}`,  data});
export const collectGame = data => axios({ 
  url: '/api/user/game/collect',
  method: 'post',
  data,
});
export const cancelCollectGame = data => axios({ 
  url: '/api/user/game/collect/del',
  method: 'post',
  data,
});
export const enterGame = data => axios({ 
  url: '/api/game/getUrl',
  method: 'post',
  data,
});


// 流水 record
export const queryRecords = data => axios({ url: "/api/user/balanceJournal/fetch",  data, config: { noLoading: HIDE_LOADING } });
export const queryRecordType = data => axios({ url: "/api/user/balanceJournal/type",  data, config: { noLoading: HIDE_LOADING } });

// 公告 events
export const queryBanner = data => axios({ url: "/api/open/banner/fetch",  data, config: { noLoading: HIDE_LOADING } });
export const queryNotice = data => axios({ url: "/api/open/notice/info",  data, config: { noLoading: HIDE_LOADING } });

// 首页信息
export const queryWithdrawMessage = data => axios({ url: "/api/open/withdraw/message",  data, config: { noLoading: HIDE_LOADING } });
export const queryGamewInfoMessage = data => axios({ url: "/api/open/game/info/message",  data, config: { noLoading: HIDE_LOADING } });

// 站内信 inbox
export const queryMessage = data => axios({ url: "/api/letter",  data, config: { noLoading: HIDE_LOADING } });
export const queryMessageType = data => axios({ url: "/api/letter/type",  data, config: { noLoading: HIDE_LOADING } });
export const readMessage = data => axios({ 
  url: '/api/letter/read',
  method: 'post',
  data,
});
export const deleteMessage = data => axios({ 
  url: '/api/letter/delete',
  method: 'post',
  data,
});
export const claimMessageReward = data => axios({ 
  url: '/api/letter/claim',
  method: 'post',
  data,
});


// 签到活动
export const querySignUpActivity = data => axios({ url: "/api/signUp/fetch",  data, config: { noLoading: HIDE_LOADING } });
export const queryBattlePassActivity = data => axios({ url: "/api/battlePass/fetch",  data, config: { noLoading: HIDE_LOADING } });
export const joinSignUp = data => axios({ 
  url: '/api/signUp/join',
  method: 'post',
  data,
});
export const signUp = data => axios({ 
  url: '/api/signUp/sign',
  method: 'post',
  data,
});
export const signBattlePass = data => axios({ 
  url: '/api/battlePass/sign',
  method: 'post',
  data,
});

export const queryDailyDepositActivity = data => axios({ url: "/api/signUpPro/fetch",  data, config: { noLoading: HIDE_LOADING } });
export const signDailyDeposit = data => axios({ 
  url: '/api/signUpPro/sign',
  method: 'post',
  data,
});


// task 里程碑
export const queryTask = data => axios({ url: "/api/task/fetch", data, config: { noLoading: HIDE_LOADING } });
export const receiveTask = data => axios({ 
  url: '/api/task/receive',
  method: 'post',
  data,
});
export const getTaskReward = data => axios({ 
  url: '/api/task/getReward',
  method: 'post',
  data,
});
export const getTaskBoxReward = data => axios({ 
  url: '/api/task/getBoxReward',
  method: 'post',
  data,
});

// Exchange
export const queryBetMall = data => axios({ url: '/api/mallExchange/info', data, config: { noLoading: HIDE_LOADING } });
export const mallExchange = data => axios({ 
  url: '/api/mallExchange/order',
  method: 'post',
  data,
});

// 绑定上级
export const bindCode = data => axios({ 
  url: `/api/user/bind/${data.code}`,
  method: 'post',
  data,
});

// 拉新活动(大转盘)
export const queryInviteActivity = data => axios({ url: `/api/activity/invite/info`,  data });
export const queryInviteRecord = data => axios({ url: `/api/activity/invite/reward/record`,  data });
export const spinInviteBonus = data => axios({ 
  url: '/api/activity/invite/spin',
  method: 'post',
  data,
});

// 拉新活动(能量)
export const queryEnergyfill = data => axios({ url: "/api/energyfill/fetch",  data });
export const queryEnergyInviteRecord = data => axios({ url: "/api/user/effective/record/fetch",  data });
export const fillEnergy = data => axios({ 
  url: '/api/energyfill/fill',
  method: 'post',
  data,
});
export const claimEnergyReward = data => axios({ 
  url: '/api/energyfill/claim',
  method: 'post',
  data,
});

// 兑换码
export const useRedeem = data => axios({ 
  url: '/api/redemption/code/use',
  method: 'post',
  data,
});

// facebook埋点事件
export const queryFbEvent = data => axios({ url: `/api/fb/event/fetch`,  data });

// 抓娃娃
export const queryCatchDoll = data => axios({ url: "/api/grasp/fetch",  data, config: { noLoading: true }});
export const queryCatchDollRecord = data => axios({ url: "/api/grasp/log",  data });
export const catchDoll = data => axios({ 
  url: '/api/grasp/start',
  method: 'post',
  data,
});

export const queryRecall = data => axios({ url: "/api/act/fetch",  data, config: { noLoading: true }});
export const queryRecallTask = data => axios({ url: `/api/recallTask/fetch/${data.sn}`,  data });
export const claimRecallTask = data => axios({ 
  url: '/api/recallTask/claim',
  method: 'post',
  data,
});


//faq
export const queryFAQ = data => axios({ url: "/api/app/faq",  data, config: { noLoading: HIDE_LOADING } });

// winner board
export const queryWinnerBoard = data => axios({ url: "/api/open/game/info/jackpot",  data });

// pocker
export const queryPoker = data => axios({ url: "/api/poker/fetch",  data });
export const queryPokerMessage = data => axios({ url: "/api/poker/message",  data });
export const drawPoker = data => axios({ 
  url: '/api/poker/draw',
  method: 'post',
  data,
});

// 活动列表
export const queryActivity = data => axios({ url: "/api/act/list",  data });

// Lucky Spin
export const queryLuckySpin = data => axios({ url: "/api/gameTurntable/fetch",  data });
export const queryLuckySpinRecord = data => axios({ url: "/api/gameTurntable/record",  data });
export const queryLuckySpinWinner = data => axios({ url: "/api/gameTurntable/winner",  data });
export const queryLuckySpinWinnerType = data => axios({ url: "/api/gameTurntable/winner/award",  data });
export const queryLuckySpinAward = data => axios({ url: "/api/gameTurntable/amount/award",  data });
export const queryJackpot = data => axios({ url: "/api/gameTurntable/jackpot",  data, config: { noLoading: HIDE_LOADING } });
export const spinLuckySpin = data => axios({ 
  url: '/api/gameTurntable/spin',
  method: 'post',
  data,
});
export const spinTenTimes = data => axios({ 
  url: '/api//gameTurntable/spin/ten',
  method: 'post',
  data,
});

export const queryGameBetTask = data => axios({ url: "/api//task/gameBet",  data });
export const getAllBetTaskReward = data => axios({ 
  url: '/api/task/gameBet/claim/all',
  method: 'post',
  data,
});
